module.exports = __webpack_public_path__ + "static/media/YFI-logo.c69913c1.png";